import React from "react";
import { View, Image, Text, TouchableOpacity } from "react-native";

import { styles } from "./styles";

export const LabelledImageQuestion = props => {
  const { question, selectedOptions, selectOption, lang } = props;

  return (
    <View style={styles.container}>
      {question.options.map(option => {
        return (
          <TouchableOpacity
            onPress={() => selectOption(question, option)}
            key={option.virtual_id}
            style={[
              styles.box,
              selectedOptions[option.virtual_id] && styles.selectedBox,
            ]}
          >
            <Image
              source={{ uri: option.image }}
              resizeMode="contain"
              style={styles.image}
            />
            <Text style={styles.label}>{option[lang]}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};
